export const hashScrollMixin = {
    data: () => ({ shouldScroll: true }),
    updated() {
        const hash = this?.$route?.hash;

        this.$nextTick(() => {
            if (this.shouldScroll && hash) {
                const el = document.querySelector(hash);

                this.shouldScroll = false;
                el && el.scrollIntoView();
            }
        });
    },
};
